import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { routesMap } from "@/components/routes/routes";
import { useAuthStore } from "@/zustand/authStore";

function Logout() {
  const { setLogout } = useAuthStore((state) => state);

  useEffect(() => {
    setLogout();
  }, []);

  if (window.location.host.includes("demo.")) {
    const replacedDemoUrl = window.location.origin.replace(
      new RegExp("demo.", "g"),
      ""
    );
    window.location.href = replacedDemoUrl;
    return null;
  }
  return <Navigate to={routesMap.auth.login.path} />;
}

export default Logout;
